import { cn } from '@/lib/utils';
import type { ApplicationQueueView } from '@/types';

type Props = {
  value: ApplicationQueueView;
  onChange: (view: ApplicationQueueView) => void;
  activeLabel: string;
  archiveLabel: string;
  activeCount?: number | null;
  /** When true, show (…) until the server count is available (avoid flashing loaded-only totals). */
  activeCountLoading?: boolean;
  archivedCount?: number | null;
  /** When true, append "+" to the count (more pages on server). */
  activeCountHasMore?: boolean;
  archivedCountHasMore?: boolean;
  className?: string;
};

function tabCountSuffix(
  count: number | null | undefined,
  loading?: boolean,
  hasMore?: boolean,
): string {
  if (loading) return ' (…)';
  if (count == null) return '';
  return ` (${count}${hasMore ? '+' : ''})`;
}

export function ApplicationQueueToggle({
  value,
  onChange,
  activeLabel,
  archiveLabel,
  activeCount,
  activeCountLoading = false,
  archivedCount,
  activeCountHasMore = false,
  archivedCountHasMore = false,
  className,
}: Props) {
  return (
    <div
      className={cn(
        'inline-flex rounded-lg border bg-muted/40 p-0.5 text-sm',
        className,
      )}
      role="tablist"
      aria-label={activeLabel}
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === 'active'}
        className={cn(
          'rounded-md px-3 py-1.5 font-medium transition-colors',
          value === 'active'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
        onClick={() => onChange('active')}
      >
        {activeLabel}
        {tabCountSuffix(activeCount, activeCountLoading, activeCountHasMore)}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === 'archive'}
        className={cn(
          'rounded-md px-3 py-1.5 font-medium transition-colors',
          value === 'archive'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
        onClick={() => onChange('archive')}
      >
        {archiveLabel}
        {tabCountSuffix(archivedCount, false, archivedCountHasMore)}
      </button>
    </div>
  );
}
